/* eslint-disable max-lines */
// 9fbef606107a605d69c0edbcd8029e5d
export default {
  // Brand Tabs
  'header__brand-tab--tcp': 'global_TCPimg',
  'header__brand-tab-gymboree': 'global_Gymboreeimg',
  'header__brand-tab-snj': 'global_SNJimg',
  'header__brand-tab-pjp': 'global_PJPimg',
  // Promotional Banner
  promo_item: 'global_promobannerimg',
  refer_friend: 'global_referfriend',
  // Legal Links
  legal_links: 'legal_links_',
  // Copyright
  'content-copyright': 'global_copyrighttext',
  // Social Media Links
  'label-connect-with-us': 'global_connectwithustext',
  social_media_links: 'social_media_links_',
  // Promotional Area
  global_promoareaimg: 'global_promoareaimg',
  // ModuleD
  moduleD_headerlink: 'moduleD_headerlink',
  moduleD_promobanner: 'moduleD_promobanner',
  moduleD_image: 'moduleD_image_',
  moduleD_textlink: 'moduleD_textlink_',
  moduleD_button: 'moduleD_button',
  // ModuleH
  moduleH_header_text: 'moduleH_header_text',
  moduleH_cta_links: 'moduleH_cta_links_',
  moduleH_composite_image: 'moduleH_composite_image_',
  moduleH_play_button: 'moduleH_play_button',
  moduleH_pause_button: 'moduleH_pause_button',
  // Module K
  moduleK_header_text: 'moduleK_header_text',
  moduleK_promobanner_text: 'moduleK_promobanner_text_',
  moduleK_promobanner_img: 'moduleK_promobanner_img',
  moduleK_image: 'moduleK_image_',
  moduleK_image_set: 'moduleK_image_set_',
  moduleK_button: 'moduleK_button',
  moduleK_button_set: 'moduleK_button_set_',
  moduleK_play_button: 'moduleK_play_button',
  moduleK_pause_button: 'moduleK_pause_button',

  // Module A
  moduleA_header_text: 'moduleA_header_text_',
  moduleA_promobanner_text: 'moduleA_promobanner_text_',
  moduleA_promobanner_img: 'moduleA_promobanner_img',
  moduleA_image: 'moduleA_image_',
  moduleA_button: 'moduleA_button',
  moduleA_play_button: 'moduleA_play_button',
  moduleA_pause_button: 'moduleA_pause_button',
  moduleA_ribbon_promobanner_text: 'moduleA_ribbon_promobanner_text_',
  moduleA_cta_links: 'moduleA_cta_links_',
  moduleA_cta_image: 'moduleA_cta_image_',
  carousel_banner: 'carousel_banner',

  // Module Container
  moduleContainer_cta_links: 'moduleContainer_cta_links_',
  moduleContainer_cta_image: 'moduleContainer_cta_image_',
  moduleContainer_dropdown: 'moduleContainer_shop_now_dropdown',
  // Module Container Image Component
  moduleContainer_carousel_image_img: 'moduleContainer_carousel_image_img_',
  moduleContainer_carousel_image_link_cta: 'moduleContainer_carousel_image_link_cta_',
  moduleContainer_play_button: 'moduleContainer_play_button_',
  moduleContainer_pause_button: 'moduleContainer_pause_button_',
  moduleContainer_carousel_image_button_cta: 'moduleContainer_carousel_image_button_cta',
  moduleContainer_left_arrow: 'moduleContainer_left_arrow',
  moduleContainer_right_arrow: 'moduleContainer_right_arrow',

  // Module B
  moduleB_header_text: 'moduleB_header_text',
  moduleB_promo_banner_text: 'moduleB_promo_banner',
  moduleB_image: 'moduleB_image_01',
  moduleB_cta_image: 'moduleB_cta_image_',
  moduleB_cta_links: 'moduleB_cta_links_',
  moduleB_dropdown: 'moduleB_shop_now_dropdown',
  moduleB_carousel_image_img: 'moduleB_carousel_image_img_',
  moduleB_play_button: 'moduleB_play_button_',
  moduleB_pause_button: 'moduleB_pause_button_',
  moduleB_left_arrow: 'moduleB_left_arrow',
  moduleB_right_arrow: 'moduleB_right_arrow',
  // Module L
  moduleL_header_text: 'moduleL_header_text',
  moduleL_title: 'moduleL_title_',
  moduleL_promobanner_text: 'moduleL_promobanner_text',
  moduleL_image: 'moduleL_image_',
  moduleL_link: 'moduleL_link_',
  moduleL_tiles: 'moduleL_tiles_',
  moduleL_left_arrow: 'moduleL_left_arrow',
  moduleL_right_arrow: 'moduleL_right_arrow',

  // Module N
  moduleN_header_text: 'moduleN_header_text',
  moduleN_promobanner_text: 'moduleN_promobanner_text',
  moduleN_promobanner_img: 'moduleN_promobanner_img',
  moduleN_image: 'moduleN_image_',
  moduleN_cta_links: 'moduleN_cta_links_',

  // Module J
  moduleJ_header_text: 'moduleJ_header_text',
  moduleJ_promobanner_text: 'moduleJ_promobanner_text',
  moduleJ_promobanner_img: 'moduleJ_promobanner_img_',
  moduleJ_product_image: 'moduleJ_product_image_',
  moduleJ_cta_link: 'moduleJ_cta_links_',
  moduleJ_cta_btn: 'moduleJ_cta_btn',

  // Module G
  moduleG_header_text: 'moduleG_header_text',
  moduleG_promobanner_text: 'moduleG_promobanner_text',
  moduleG_image: 'moduleG_image_',
  moduleG_cta_link: 'moduleG_cta_links_',
  moduleG_add_to_bag_btn: 'moduleG_add_to_bag_btn',
  moduleG_shop_all_link: 'moduleG_shop_all_link',

  // Module Q
  moduleQ_header_text: 'moduleQ_header_text',
  moduleQ_promobanner_text: 'moduleQ_promobanner_text',
  moduleQ_promobanner_img: 'moduleQ_promobanner_img_',
  moduleQ_product_image: 'moduleQ_product_image_',
  moduleQ_cta_link: 'moduleQ_cta_links_',
  moduleQ_cta_btn: 'moduleQ_cta_btn',

  // Module R
  moduleR_header_text: 'moduleR_header_text',
  moduleR_promobanner_text: 'moduleR_promobanner_text',
  moduleR_product_image: 'moduleR_product_image_',
  moduleR_cta_link: 'moduleR_cta_links_',
  moduleR_cta_btn: 'moduleR_cta_btn',

  // Module T
  moduleT_header_text: 'moduleT_header_text',
  moduleT_promobanner_text: 'moduleT_promobanner_text',
  moduleT_promobanner_img: 'moduleT_promobanner_img_',
  moduleT_cta_links: 'moduleT_cta_links_',
  moduleT_cta_image: 'moduleT_cta_image_',

  // Module E
  moduleE_eyebrowImage_img: 'moduleE_eyebrowImage_img_',
  moduleE_eyebrow_text: 'moduleE_eyebrow_text',
  moduleE_header_text: 'moduleE_header_text',
  moduleE_promo_text: 'moduleE_promo_text',
  moduleE_promobanner_text: 'moduleE_promobanner_text',
  moduleE_carousel_img: 'moduleE_carousel_img_',
  moduleE_carousel_cta: 'moduleE_carousel_cta_',
  moduleE_small_image: 'moduleE_small_image_',
  moduleE_small_img_header_text: 'moduleE_small_img_header_text_',
  moduleE_small_img_cta: 'moduleE_small_img_cta_',
  moduleE_small_img: 'moduleE_small_img_',
  moduleE_promo_area_img: 'moduleE_promo_area_img',
  moduleE_promo_area_img_cta: 'moduleE_promo_area_img_cta',
  moduleE_cta_image: 'moduleE_cta_image_',
  moduleE_cta_links: 'moduleE_cta_links_',
  moduleE_dropdown: 'moduleE_shop_now_dropdown',
  moduleE_carousel_image_img: 'moduleE_carousel_image_img_',
  moduleE_carousel_image_link_cta: 'moduleE_carousel_image_link_cta_',
  moduleE_carousel_image_button_cta: 'moduleE_carousel_image_button_cta_',
  moduleE_carousel_image_link: 'moduleE_carousel_image_link_',
  moduleE_cta_button: 'moduleE_cta_button',

  // Module Image Text
  moduleImageText_headline_text: 'moduleImageText_headerline_text',
  moduleImageText_headsubline_text: 'moduleImageText_headersubline_text',
  moduleImageText_image: 'moduleImageText_image',
  moduleImageText_bgwrapper: 'moduleImageText_bgwrapper',
  moduleImageText_cta_image: 'moduleImageText_cta_image_',
  moduleImageText_cta_links: 'moduleImageText_cta_links_',
  moduleImageText_dropdown: 'moduleImageText_shop_now_dropdown',

  // Added To Bag
  addedtobag_btnviewbag: 'addedtobag-btnviewbag',
  addedtobag_btnpaypal: 'addedtobag-btnpaypal',
  addedtobag_btncheckout: 'addedtobag-btncheckout',
  // MobileHeader
  global_headerpanel: 'global_headerpanel',
  global_findastoretext: 'global_findastoretext',
  global_headerpanelcollapsedicon: 'global_headerpanelcollapsedicon',
  global_headerpanelexpandedicon: 'global_headerpanelexpandedicon',
  global_headerpanelbagicon: 'global_headerpanelbagicon',
  global_headerpanelbagitemtext: 'obal_headerpanelbagicon',
  global_headerpanelwelcometext: 'global_headerpanelwelcometext',
  // MobileHeader
  global_promobanner_title_0: 'global_promobanner_title_0',
  global_promobanner_title_1: 'global_promobanner_title_1',
  global_promobanner_left_arrowRight: 'global_promobanner_left_arrowRight',
  global_promobanner_right_arrow: 'global_promobanner_right_arrow',
  // Order Ledger
  order_ledger_section_label: 'orderLedgerBox',
  order_ledger_item_label: 'orderLedgerItemLbl',
  order_ledger_coupons_label: 'orderLedgerCouponsLbl',
  order_ledger_shipping_label: 'orderLedgerShippingLbl',
  order_ledger_promotion_label: 'orderLedgerPromotionLbl',
  order_ledger_estimated_tax_label: 'orderLedgerTaxLbl',
  order_ledger_estimated_total_label: 'orderLedgerTotalLbl',
  order_ledger_gift_card_label: 'orderLedgerGiftCardLbl',
  order_ledger_balance_total_label: 'orderLedgerBalanceTotalLbl',
  order_ledger_total_order_savings_label: 'orderLedgerTotalOrderSavingsLabel',
  order_ledger_submit_order_btn: 'SubmitOrderBtn',
  order_ledger_summary_header: 'OrderSummaryHdr',

  // CardTile
  cart_item_image: 'cartItemImage',
  cart_item_title: 'cartItemTitle',
  cart_item_upc: 'cartItemUpc',
  cart_item_brand_logo: 'cartItemBrandLogo',
  cart_item_edit_link: 'cartItemEditLink',
  cart_item_price: 'cartItemPrice',
  cart_item_points: 'cartItemPoints',
  cart_item_total_price: 'cartItemTotalPrice',
  cart_item_color: 'cartItemColor',
  cart_item_size: 'cartItemSize',
  cart_item_no_rush_radio_button: 'ItemNoRushRadioButton',
  cart_item_cartNoRush: 'cartNoRush',
  cart_item_pickup_radio_today_button: 'ItemPickUpTodayRadioButton',
  cart_item_pickup_today: 'cartPickUpToday',
  cart_item_ship_to_home_radio_button: 'ItemShipToHomeRadioButton',
  cart_item_ship_to_home: 'cartShipToHome',
  cart_item_cross_button: 'cartItemCrossButton',

  // Category Loyalty Banner
  category_loyalty_txt_lbl: 'category-loyalty-banner-label',
  category_loyalty_banner_img: 'category-loyalty-banner-slideImage',
  carousel_wrapper: 'tcp-carousel-wrapper-outfits-image',

  // Outfit PLP
  outfitplp_firstday: 'outfitplp-firstdayoutfit-heading',
  outfitplp_title: 'outfitplp-outfits-title',
  outfitplp_tile_image: 'outfitplp-outfits Tile-Image',
  ourfitplp_shopthislook_lbl: 'outfitplp-shop-this-look-label',

  // Outfit PDP
  outfitpdp_outfit_img: 'outfitpdp-outfit-image',
  outfitpdp_back_link: 'outfitpdp-Back-link',
  outfitpdp_productcount_lbl: 'outfitpdp-productcount-label',
  outfitpdp_product_img: 'outfit-product-Image',
  outfitpdp_product_title: 'outfitpdp-product-title-link',
  outfitpdp_unavailable_item: 'pdp-unavailableItem-text',
  outfitpdp_complete_look: 'pdp-completeThislook',
  pdp_product_title_heading: 'pdp-product-title-heading',
  pdp_product_price: 'pdp-product-price',
  pdp_product_promotion_txt: 'pdp-product-loyalty-promotion-txt',
  pdp_color_lbl: 'pdp-color-label',
  pdp_color_selector_lbl: 'pdp-color-selector-label',
  pdp_colors_list: 'pdp-colors-list',
  pdp_size_lbl: 'pdp-size-label',
  pdp_size_selctor_lbl: 'pdp-size-selector-label',
  pdp_size_list: 'pdp-size-list',
  pdp_sizechart_link: 'pdp-sizechart-link',
  pdp_view_product_detail: 'pdp-view-product-detail-link',
  pdp_add_to_bag_btn: 'pdp-addToBag-button',

  // Empty Bag Locator
  empty_bag_Msg: 'cartEmptyBagMessage',
  empty_bag_loginUserCTA: 'cartRegisteredShopNowButton',
  empty_bag_guestUserCTA: 'cartGuestLoginCta',
  empty_bag_recommendation_msg: 'cartRecommendationMessage',
  empty_sfl_Msg_1: 'cartEmptySFLMessage_1',
  empty_sfl_Msg_2: 'cartEmptySFLMessage_2',

  // Country Selector
  header_country_flag: 'header_country_flag',
  footer_country_flag: 'footer_country_flag',
  header_language_selected: 'header_language_selected',
  footer_language_selected: 'footer_language_selected',
  country_selector_ship_to_modal: 'country_selector_ship_to_modal',
  ship_to_text_1: 'ship_to_text_1',
  ship_to_text_2: 'ship_to_text_2',
  country: 'country',
  language: 'language',
  currency: 'currency',
  country_selector_save_btn: 'country_selector_save_btn',
  country_selector_tnc_text: 'country_selector_tnc_text',
  country_selector_tnc_link: 'country_selector_tnc_link',

  // PLPFilters
  plp_filter_label_filterby: 'plp_filter_label_filterby',
  plp_filter_category: 'plp_filter_category',
  plp_filter_category_option_: 'plp_filter_category_option_',
  plp_filter_category_apply: 'plp_filter_category_apply',
  plp_filter_size: 'plp_filter_size',
  plp_filter_size_option_: 'plp_filter_size_option_',
  plp_filter_size_apply: 'plp_filter_size_apply',
  plp_filter_color: 'plp_filter_color',
  plp_filter_color_option_: 'plp_filter_color_option_',
  plp_filter_color_apply: 'plp_filter_color_apply',
  plp_filter_gender: 'plp_filter_gender',
  plp_filter_gender_option_: 'plp_filter_gender_option_',
  plp_filter_gender_apply: 'plp_filter_gender_apply',
  plp_filter_price: 'plp_filter_price',
  plp_filter_price_option_: 'plp_filter_price_option_',
  plp_filter_fit: 'plp_filter_fit',
  plp_filter_fit_option_: 'plp_filter_price_fit_',
  plp_filter_size_range: 'plp_filter_size_range',
  plp_filter_size_range_option_: 'plp_filter_size_range_option_',
  plp_filter_size_range_apply: 'plp_filter_size_range_apply',
  plp_filter_filtering_by: 'plp_filter_filtering_by',
  // Product Tile locators
  global_productbadge_txt: 'global-productbadge-txt',
  global_productimg_imagelink: 'global-productimg-imagelink',
  global_imagecursors_arrows: 'global-imagecursors-arrows',
  global_favorite_button: 'global-favorite-button',
  global_Extended_sizes_text: 'global-Extended-sizes-text',
  global_Price_text: 'global-Price-text',
  global_ColorSwatch_Swatch_link: 'global-ColorSwatch-Swatch link',
  global_loyalty_text: 'global-loyalty-text',
  global_addtocart_Button: 'global-addtocart-Button',

  // PLP SEO TEXT
  plp_seo_module: 'plp_seo_module',
  plp_seo_readmore: 'plp_seo_module_readmore',
  plp_seo_readless: 'plp_seo_module_readless',

  // SEO text
  seo_title: 'seo_title',
  seo_body: 'seo_body',
  seo_readmore: 'seo_readmore',
  seo_readless: 'seo_readless',

  // PLP Review Ratings
  plp_rating_review: 'plp_rating_review_text',

  // Track Order Locator
  track_order_click_here: 'track_order_click_here',

  // PLCC Locators
  plcc_first_name: 'plcc_first_name',
  plcc_middle_name: 'plcc_middle_name',
  plcc_last_name: 'plcc_last_name',
  plcc_address_1: 'plcc_address_1',
  plcc_address_2: 'plcc_address_2',
  plcc_city: 'plcc_city',
  plcc_state: 'plcc_state',
  plcc_zip_code: 'plcc_zip_code',
  plc_mobile_no: 'plc_mobile_no',
  plcc_email: 'plcc_email',
  plcc_alt_mobile_no: 'plcc_alt_mobile_no',
  plcc_date: 'plcc_date',
  plcc_month: 'plcc_month',
  plcc_year: 'plcc_year',
  plcc_SSN: 'plcc_SSN',
  plcc_submit_btn: 'plcc_submit_btn',
  plcc_back_btn: 'plcc_back_btn',
  plcc_apply_now_close_btn: 'plcc_apply_now_close_btn',
  plcc_apply_btn: 'plcc_apply_btn',
  plcc_notme_btn: 'plcc_notme_btn',
  plcc_apply_now_modal: 'plcc_apply_now_modal',
  plcc_time_out_modal_close_btn: 'plcc_time_out_modal_close_btn',
  plcc_time_out_modal_restart_application: 'plcc_time_out_modal_restart_application',
  plcc_time_out_modal_return_to_checkout: 'plcc_time_out_modal_return_to_checkout',
  plcc_time_out_modal_logo: 'plcc_time_out_modal_logo',
  plcc_time_out_modal_text: 'plcc_time_out_modal_text',
  plcc_time_out_modal_continue: 'plcc_time_out_modal_continue',

  // BreadCrumbs Locators
  breadCrumb_L1_Category: 'breadcrumb-L1-link',
  breadCrumb_L2_Category: 'breadcrumb-L2-link',
  breadCrumb_L3_Category: 'breadcrumb-L3-link',

  // CLP Navigation Locators
  plp_left_Nav_L2: 'leftnav-L2-Link',
  plp_left_Nav_L3: 'leftnav-L3-link',
  plp_left_Nav_header: 'products-header-txt',

  // PLP Sort by Options
  plp_sort_by_text: 'global-sortby-text',
  plp_sort_recommended: 'sortoption-recommended-option',
  plp_sort_high_to_low: 'sortoption-Price: High to low-option',
  plp_sort_low_to_high: 'sortoption-Price: Low to High-option',
  plp_sort_newest: 'sortoption-Newest-option',
  plp_sort_favorited: 'sortoption-Most Favorited-option',
  plp_sort_top_rated: 'sortoption-Top Rated-option',

  // PDP ProductImages
  pdp_product_titles: 'pdp_product_titles',
  pdp_main_image: 'pdp_main_image',
  pdp_alt_image: 'pdp_alt_image',
  pdp_image_carousel_icon: 'pdp_image_carousel_icon',
  pdp_full_size_btn: 'pdp_full_size_btn',
  pdp_full_size_image_modal: 'pdp_full_size_image_modal',
  pdp_zoomed_image_closed_btn: 'pdp_zoomed_image_closed_btn',

  // PDP - Add to Bag section
  pdp_product_badges: 'pdp_product_badges',
  pdp_write_review_icon: 'pdp_write_review_icon',
  pdp_current_product_price: 'pdp_current_product_price',
  pdp_discounted_product_price: 'pdp_discounted_product_price',
  pdp_loyalty_text: 'pdp_loyalty_text',
  pdp_favorite_icon: 'pdp_favorite_icon',
  pdp_device_image_carousel_btn: 'pdp_device_image_carousel_btn',
  pdp_color_value: 'pdp_color_value',
  pdp_color_label: 'pdp_color_label',
  pdp_color_swatch: 'pdp_color_swatch',
  pdp_fit_label: 'pdp_fit_label',
  pdp_fit_value: 'pdp_fit_value',
  pdp_error_alerts: 'pdp_error_alerts',
  pdp_size_chart: 'pdp_size_chart',
  pdp_size_label: 'pdp_size_label',
  pdp_size_value: 'pdp_size_value',
  pdp_size_another_available_size: 'pdp_size_another_available_size',
  pdp_add_to_bag_CTA: 'pdp_add_to_bag_CTA',
  pdp_quantity: 'pdp_quantity',
  pdp_choose_store: 'pdp_choose_store',
  pdp_free_shipping_label: 'pdp_free_shipping_label',
  pdp_pick_up_in_store: 'pdp_pick_up_in_store',
  pdp_pick_up_in_store_modal: 'pdp_pick_up_in_store_modal',
  pdp_discounted_percentage: 'Product Discount Percentage',
  pdp_favorite_icon_count: 'Favorites count',
  pdp_anchor_complete_the_look: 'Complete The Look',
  pdp_rating_reviews: 'ratings_and_reviews_section',
  pdp_rating_reviews_title: 'ratings_and_reviews_title',
  pdp_rating_reviews_count: 'ratings_and_reviews_count',

  // PDP product description locators
  pdp_product_description_label: 'product_description_title',
  pdp_short_description: 'short-description',
  pdp_long_description: 'long_description',
  pdp_claim_message: 'claim_message',
  pdp_product_part_number: 'part_number',
  pdp_read_more: 'read_more',
  pdp_read_less: 'read_less',

  // Quick View Modal
  quick_view_add_to_bag_header: 'quick_view_add_to_bag_header',
  quick_view_modal: 'quick_view_modal',
  quick_view_product_name: 'quick_view_product_name',
  quick_view_product_image: 'quick_view_product_image',
  quick_view_View_Product_details: 'quick_view_View_Product_details',
  quick_view_icon_btn: 'quick_view_icon_btn',

  // Store locator
  store_drawerlink: 'store_drawerlink',
  store_markericon: 'store_markericon',
  store_storetime: 'store_storetime',
  store_findastore: 'store_findastore',
  store_search_textbox: 'store_search_textbox',
  store_searchicon: 'store_searchicon',
  store_outlet_storesbutton: 'store_outlet_storesbutton',
  store_namelabel: 'store_namelabel',
  store_distancelabel: 'store_distancelabel',
  store_addresslabel: 'store_addresslabel',
  store__storephonelabel: 'store__storephonelabel',
  store_retailstorelabel: 'store_retailstorelabel',
  store_outletstorelabel: 'store_outletstorelabel',
  store_gymboreetstorelabel: 'store_gymboreetstorelabel',
  store_yourstorelabel: 'store_yourstorelabel',
  store_changefavoriterstorebutton: 'store_changefavoriterstorebutton',
  store_setfavoriterstorebutton: 'store_setfavoriterstorebutton',
  store_getdirectionsbutton: 'store_getdirectionsbutton',
  store_callstorebutton: 'store_callstorebutton',
  store_malltypelabel: 'store_malltypelabel',
  store_entrancetypelabel: 'store_entrancetypelabel',
  store_seestoredetailslink: 'store_seestoredetailslink',
  store_seestorehourslink: 'store_seestorehourslink',
  store_storelistUSanCanadalink: 'store_storelistUSanCanadalink',
  store_invalidziperrorlabel: 'store_invalidziperrorlabel',
  store_internationalstorelink: 'store_internationalstorelink',
  store_seemorestoreslink: 'store_seemorestoreslink',
  store_backlink: 'store_backlink',
  store_InternationalstoreCountrylink: 'store_InternationalstoreCountrylink',
  store_Internationalstorestatelabel: 'store_Internationalstorestatelabel',
  store_Internationalstoreshopinshoplabel: 'store_Internationalstoreshopinshoplabel',
  store_USCanadasearchlabel: 'store_US&Canadasearchlabel',
  store_USCanadaselectstatelabel: 'store_USCanadaselectstatelabel',
  store_USCanadaselectstatelink: 'store_USCanadaselectstatelink',
  store_USCanadabacklink: 'store_USCanadabacklink',
  store_USCanadanamelabel: 'store_USCanadanamelabel',
  store_USCanadaaddresslabel: 'store_USCanadaaddresslabel',
  store_USCanadastorephonelabel: 'store_USCanadastorephonelabel',
  store_USCanadagymboreetstorelabel: 'store_USCanadagymboreetstorelabel',
  store_USCanadastatelabel: 'store_USCanadastatelabel',
  store_USCanadastateaccordion: 'store_USCanadastateaccordion',
  store_USCanada_link: 'store_US&Canada_link',
  store_International_link: 'store_international_link',
  store_InternationalSearch_lbl: 'store_InternationalSearchlabel',

  // gift services
  gift_service: 'gift-service',
  giftservice_detailslnk: 'giftservice-detailslnk',
  addMessage_txt: 'addMessage-txt',
  logo_TCP: 'logo-TCP',
  logo_gymboree: 'logo-gymboree',
  logo_pjp: 'logo-pjp',
  giftService_list: 'giftService-list',
  details_modal: 'details-modal',

  // favorite list
  fav_brand_title: 'Brand',
  fav_brand_tcp_lbl: 'The Childrens Place',
  fav_brand_gym_lbl: 'Gymboree',
  fav_brand_snj_lbl: 'Sugar&Jade',
  fav_lbl_myFavorites: 'My Favorites',
  fav_lbl_editListSettings: 'Edit List Settings',
  fav_heading: 'favorite-heading',
  fav_dropdown_heart_icon: 'favorite-dropdown-heart-icon',
  fav_dropdown: 'favorite-dropdown',
  fav_list_lbl: 'favorite-list-heading-label',
  fav_list_name_lbl: 'favorite-list-name',
  fav_list_name_count: 'favorite-list-count',
  fav_create_new_list_cta: 'favorite-list-create-new-list-cta',
  fav_create_list_modal_heading: 'favorite-createnewlistmodal-heading',
  fav_list_name_txtfield: 'favorite-listname-textfield',
  fav_edit_list_heading: 'favorite-editlist-heading',
  email_link: 'sharing-email Link',
  facebook_link: 'sharing-Facebook-link',
  copy_link: 'sharing-copy-link',
  recently_added: 'sortby-recentlyadded-link',
  price_low_to_high: 'sortby-pricelowtohigh-link',
  price_high_to_low: 'sortby-pricehightolow-link',
  new_arrivals: 'sortby-newarrivals-link',
  clearance: 'sortby-clearance-link',
  brand_heading: 'brand-label',
  brand_TCP_checkbox: 'brandtcp-checkbox',
  brand_gym_checkbox: 'brandgymboree-checkbox',
  brand_snj_checkbox: 'brandsnj-checkbox',
  display_by_heading: 'displayby-heading',
  all_dropdown_options: 'displayby-all-link',
  available_dropdown_options: 'displayby-available-link',
  soldout_dropdown_options: 'displayby-soldout-link',
  purchased_dropdown_options: 'displayby-purchased-link',
  product_image: 'product-images',
  edit_links: 'edit-links',
  product_tile: 'product-tile',
  purchased_count: 'purchased-count',
  purchased_count_lbl: 'purchased-count-label',
  move_to_another_list: 'movetoanother-link',
  my_favourite_locator: 'my_favourite_locator',
  create_favourite_wish_list: 'create_favourite_wish_list',

  // module M
  moduleM_header_text: 'moduleM_header_text',
  moduleM_promobanner_text: 'moduleM_promobanner_text',
  moduleM_image: 'moduleM_image',
  moduleM_cta_btn: 'moduleM_cta_btn',
  moduleM_cta_links: 'moduleM_cta_links',

  global_bagpagebackbutton: 'global_bagpagebackbutton',

  // QRScanner
  qrscanner_plp_gif_animation: 'qrscanner_plp_gif_animation',

  // OrderDetails
  order_detail_edd: 'order-detail-edd',
  help_center: 'help-center-section',
  thankyou_message: 'thankyou-message',
  whats_next: 'whats-next-section',
  order_total: 'order-total',
  item_count: 'item-count',
  order_date: 'order-date',
  order_number: 'order-number',
  order_details_heading: 'order-details-heading',
  order_product_list: 'order-product-list',
  term_And_Condition_Text: 'termAndConditionText',
  privacy_text: 'PrivacyText',

  // Module Tabbed Carousel
  moduleTabbed_image_link: 'moduleTabbed_image_link_',
};
